/**
 * Utilitaires de dates pour Ernest
 * 
 * IMPORTANT: Ces fonctions utilisent l'heure LOCALE de l'utilisateur pour
 * déterminer le mois/semaine/jour en cours, puis convertissent en ISO (UTC)
 * pour les requêtes Supabase.
 */

/**
 * Retourne le début du mois en cours selon l'heure LOCALE de l'utilisateur
 * Converti en ISO (UTC) pour les requêtes Supabase
 */
export const getMonthStartUTC = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  return new Date(year, month, 1, 0, 0, 0, 0).toISOString();
};